export const getElectricityEmissionFactor = (
  specificIndirectEmbeddedEmissions: number,
  electricityConsumption: number
) => {
  return specificIndirectEmbeddedEmissions / electricityConsumption
}
